import { render, staticRenderFns } from "./Theme-Switcher.vue?vue&type=template&id=08dc8985&scoped=true&"
import script from "./Theme-Switcher.vue?vue&type=script&lang=js&"
export * from "./Theme-Switcher.vue?vue&type=script&lang=js&"
import style0 from "./Theme-Switcher.vue?vue&type=style&index=0&id=08dc8985&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dc8985",
  null
  
)

export default component.exports